<template>
    <span>
        <el-select 
            class="filterItem-value"
            v-if="showInput" 
            v-model="filterItem.value[0]" 
            filterable>
            <el-option
                v-for="item in userList"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
                />
        </el-select>
        <el-select 
            class="filterItem-value"    
            v-if="showMultSelect" 
            v-model="filterItem.value" 
            multiple 
            filterable
            collapse-tags
            collapse-tags-tooltip>
            <el-option
                v-for="item in userList"
                :key="item.Value"
                :label="item.Text"
                :value="item.Value"
                />
        </el-select>
    </span>
</template>

<script>
    import baseFilter from "../../BaseFilter"
    import { getAllUser } from "@/apis/httpHelper"

    export default {
        name:"SingleUserFieldFilter",
        mixins:[baseFilter],
        data:function(){
            return{
                userList:[]
            }
        },
        created:function(){
            getAllUser()
            .then(x=>{
                this.userList = x.Result.Options;
            }).catch(x=>{
                console.log(x);
            });
        },
        methods:{

        }
    }
</script>